/* ==========================================================================
   REMRY — HEADER
   Mobile menu, and hiding the sticky header on scroll-down so the page has
   the full viewport while reading.
   ========================================================================== */

(() => {
  const init = () => {
    const header = document.querySelector('[data-header]');
    if (!header || header.dataset.bound) return;
    header.dataset.bound = 'true';

    /* --- Mobile menu ---------------------------------------------------- */

    const toggle = header.querySelector('[data-menu-toggle]');
    const drawer = header.querySelector('[data-menu-drawer]');

    if (toggle && drawer) {
      const setOpen = (open) => {
        toggle.setAttribute('aria-expanded', String(open));
        drawer.hidden = !open;
        document.body.classList.toggle('is-locked', open);
      };

      toggle.addEventListener('click', () => {
        setOpen(toggle.getAttribute('aria-expanded') !== 'true');
      });

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && toggle.getAttribute('aria-expanded') === 'true') {
          setOpen(false);
          toggle.focus();
        }
      });

      // A resize into the desktop layout must not leave the body locked.
      matchMedia('(min-width: 750px)').addEventListener('change', (event) => {
        if (event.matches) setOpen(false);
      });
    }

    /* --- Hide on scroll down -------------------------------------------- */

    if (!header.classList.contains('header--sticky')) return;

    let lastY = window.scrollY;
    let ticking = false;

    const onScroll = () => {
      if (ticking) return;
      ticking = true;

      requestAnimationFrame(() => {
        ticking = false;
        const y = window.scrollY;

        // Never hide while a drawer is open, or near the very top where the
        // header is part of the composition rather than furniture.
        const menuOpen = toggle?.getAttribute('aria-expanded') === 'true';
        if (menuOpen || y < 120) {
          header.classList.remove('is-hidden');
          lastY = y;
          return;
        }

        // A small threshold keeps trackpad jitter from flickering the header.
        if (Math.abs(y - lastY) < 8) return;

        header.classList.toggle('is-hidden', y > lastY);
        lastY = y;
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    // Focus moving into the header (keyboard navigation) must reveal it.
    header.addEventListener('focusin', () => header.classList.remove('is-hidden'));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
